var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFisheye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 375.62 80.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#253858;}.cls-2{fill:#2684ff;}.cls-3{fill:url(#New_Gradient_Swatch_1);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 0.07,
    y1: 33.68,
    x2: 45.5,
    y2: 47.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fisheye-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.77,4.58v7.57H105.55V33.26h26.22v7.57H105.55V62.39H97.63V4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.94,1.5a4.94,4.94,0,0,1,5.28,5.28,5.28,5.28,0,0,1-10.56,0A4.94,4.94,0,0,1,145.94,1.5Zm-3.87,16.9h7.57v44h-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.89,63.27A33.9,33.9,0,0,1,159.58,60V52a34.4,34.4,0,0,0,15.66,4.31c5.81,0,8.8-2.38,8.8-5.81s-2.55-5.28-10.91-7.3c-9.77-2.37-13.9-6.16-13.9-13.38,0-7.66,5.9-12.32,15.93-12.32a31.24,31.24,0,0,1,14.17,3.17v7.83c-5.28-2.64-9.59-4-14.25-4-5.54,0-8.54,1.94-8.54,5.37,0,3.08,2.11,5,10.21,7,9.77,2.38,14.7,6,14.7,13.64C191.44,57.73,186.69,63.27,174.89,63.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.55,62.39H230V37.93c0-9.06-3.17-13.55-10.38-13.55-7,0-11.88,4.66-11.88,13.55V62.39h-7.57V0h7.57V25.7a16.07,16.07,0,0,1,14.52-8.18c9.86,0,15.31,6.69,15.31,19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.23,63.27c-16.46,0-23.67-9.5-23.67-23,0-13.29,7.39-22.79,20.77-22.79,13.55,0,19,9.42,19,22.79v3.43H253.21c1.06,7.48,5.9,12.32,16.28,12.32a39,39,0,0,0,13.38-2.37v7C279.26,62.57,273.72,63.27,269.23,63.27Zm-16.1-26h24.55c-.44-8.18-4.14-12.85-11.7-12.85C258,24.38,253.92,29.57,253.12,37.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.38,18.39h8.1l14.08,37.66,14.08-37.66h8.1L317.1,61c-4.93,12.58-7.74,19.09-18.92,19.09a20,20,0,0,1-8.1-1.23V72.33a27.12,27.12,0,0,0,7.66,1.06c6.16,0,8.89-4.22,12.5-13.82h-4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.51,63.27c-16.46,0-23.67-9.5-23.67-23,0-13.29,7.39-22.79,20.77-22.79,13.55,0,19,9.42,19,22.79v3.43H343.5c1.06,7.48,5.9,12.32,16.28,12.32a39,39,0,0,0,13.38-2.37v7C369.55,62.57,364,63.27,359.51,63.27Zm-16.1-26H368c-.44-8.18-4.14-12.85-11.7-12.85C348.25,24.38,344.2,29.57,343.41,37.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.12,2.71c-11.19,0-20,8-20,18,0,7.64,5.24,13.2,11.44,13.2A10.76,10.76,0,0,0,35.63,23.15a7.24,7.24,0,0,0-.29-2.06A39.06,39.06,0,0,1,48.5,32.31C45.05,38.46,39.65,45,31.62,45h0A12.68,12.68,0,0,1,19.24,34.17a2,2,0,0,0-2-1.72H2a2,2,0,0,0-2,2.16A31.39,31.39,0,0,0,31.5,64.22h0c19,0,30.26-13.66,38.85-31.31a2,2,0,0,0,0-1.77C67.88,26.2,54.2,2.71,33.12,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.52,32.31h-22C45.05,38.46,39.65,45,31.62,45h0A12.68,12.68,0,0,1,19.24,34.17a2,2,0,0,0-2-1.72H2a2,2,0,0,0-2,2.16A31.39,31.39,0,0,0,31.5,64.22h0c19,0,30.26-13.66,38.85-31.31A2,2,0,0,0,70.52,32.31Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFisheye);
export default __webpack_public_path__ + "static/media/logo-fisheye.92a2e65c2533b453d8d1469574c3984b.svg";
export { ForwardRef as ReactComponent };